"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var nested_display_logic_html_1 = __importDefault(require("./nested-display-logic.html"));
require("./nested-display-logic.less");
(function (module) {
    'use strict';
    module.component('prNestedDisplayLogic', {
        templateUrl: nested_display_logic_html_1.default,
        controller: 'prNestedDisplayLogicController as $ctrl',
        bindings: {
            displayLogic: '=',
            parentDisplayLogic: '=',
            sourceId: '<',
            listIndex: '=',
            isRaterCategory: '<'
        }
    });
})(angular.module('qualtrics.pr'));
